import React, { useEffect } from "react";
import { SetFieldValue } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useAuth } from "../../../../auth/context/AuthProvider";

interface PropertySelectComponentProps {
    setValue: SetFieldValue<any>;
}

const PropertySelectComponent: React.FC<PropertySelectComponentProps> = ({ setValue }) => {
    const { user } = useAuth();

    useEffect(() => {
        if (user?.active_property_id) {
            setValue("filter.property_id", user.active_property_id);
        }
    }, [user, setValue]);

    return (
        <div>
            <Form.Label className="me-2">Current Property:</Form.Label>

            <span className="me-2 fw-bold">
                {user?.active_property}
            </span>
        </div>
    );
};

export default PropertySelectComponent;
